export default {
  baseUrl (id) {
    return `sliders/${id}/slides`
  },

  index (sliderId, request) {
    return axios.get(this.baseUrl(sliderId), { params: request })
  },

  show (sliderId, id) {
    return axios.get(`${this.baseUrl(sliderId)}/${id}`)
  },

  create (sliderId, slide) {
    return axios.post(`${this.baseUrl(sliderId)}`, {
      slide: slide
    })
  },

  update (sliderId, request) {
    return axios.put(`${this.baseUrl(sliderId)}/${request.id}`, {
      slide: request
    })
  },

  delete (sliderId, request) {
    return axios.delete(`${this.baseUrl(sliderId)}/${request.id}`)
  }
}



// WEBPACK FOOTER //
// ./src/model/Slide.js